// global store
const store = {
  // 文件选择列表(MoveCopy场景)中列表切换params信息堆栈，进入一个列表push params，
  // 点击返回按钮 pop 出 params, 调用fetchList， 解决返回键导航问题
  selectListStack: [],
  actionSheet: {},
  actionState: {},
  newFolder: {},
  sortInfo: '',
  collabState: {},
  imgPreviewInfo: {
    ids: [],
    items: {}
  },
  // 已经邀请的协作成员
  invitedCollMemberIds: [],
  navStatus: -1
}

export default store
